enum ASSIGNMENTS {
	ASSIGNMENTS = '/api/assignments',
	ASSIGNMENTS_BY_ID = '/api/assignments/'
}

export default ASSIGNMENTS;
